<div class="suggestions_box">
  <div class="destination" *ngFor="let suggestion of suggestions" (click)="getAddressByPlaceId(suggestion)">
    <ion-icon name="dp-location"></ion-icon>
    <div class="info">
      <div class="name">{{suggestion.main}}</div>
      <div class="location">{{suggestion.secondary}}</div>
    </div>
  </div>
</div>